import React, { useEffect, useState } from 'react';
import { apiFetch } from '../../config/api';
import { useIdioma } from '../../i18n';
import { useFormato } from '../../i18n/formato';

/* O que cada pacote cobra, em dólar, como os planos (`PRECOS` em config/stripePrices): anual = 10 meses. */
const PRECO_DO_PACOTE = { Starter: 29, Plus: 79, Max: 199 };
const ATIVOS = ['Starter', 'Plus', 'Max'];

/**
 * O monitor de IA na tela de planos: um add-on, numa assinatura separada do
 * plano. Os pacotes vêm do servidor (só os que têm preço configurado); sem
 * nenhum, o cartão não aparece. Comprar ou trocar vai ao Stripe pelo mesmo
 * caminho da troca de plano; a volta (`/plans?monitor=ok`) avisa que o
 * webhook pode levar um instante.
 */
const PlanoMonitorIa = ({ anual, analista, aoAvisar }) => {
  const { t } = useIdioma();
  const { numero, moeda } = useFormato();
  const [dados, setDados] = useState(null);
  const [ocupado, setOcupado] = useState(false);

  useEffect(() => {
    apiFetch('/monitor-ia/pacotes')
      .then((r) => (r.ok ? r.json() : null))
      .then(setDados)
      .catch(() => {});
    if (new URLSearchParams(window.location.search).get('monitor') === 'ok') {
      aoAvisar({ tipo: 'ok', texto: 'monitorPlano.recebido' });
      window.history.replaceState({}, '', window.location.pathname);
    }
  }, [aoAvisar]);

  if (!dados || dados.pacotes.length === 0) return null;
  const atual = ATIVOS.includes(dados.atual) ? dados.atual : null;

  const ir = async (rota, corpo) => {
    setOcupado(true);
    aoAvisar({ tipo: '', texto: '' });
    try {
      const r = await apiFetch(rota, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(corpo || {}) });
      const json = await r.json();
      if (!r.ok) throw new Error(json.error || 'erros.requisicao');
      if (json.url) {
        window.location.href = json.url;
        return;
      }
      aoAvisar({ tipo: 'ok', texto: 'monitorPlano.cancelado' });
    } catch (erro) {
      aoAvisar({ tipo: 'crit', texto: erro.message });
    }
    setOcupado(false);
  };

  return (
    <section className="lg-cartao lgl-monitor" aria-labelledby="lgl-monitor-titulo">
      <div className="lg-cartao-cabeca">
        <h2 id="lgl-monitor-titulo">{t('monitorPlano.titulo')}</h2>
        {dados.atual === 'Cortesia' && <span className="sp-tag sp-tag-accent">{t('monitorPlano.cortesia')}</span>}
      </div>
      <p className="lgl-monitor-chamada">{t('monitorPlano.chamada')}</p>
      <div className="lgl-monitor-pacotes">
        {dados.pacotes.map((p) => {
          const priceId = anual ? p.anual : p.mensal;
          const valor = PRECO_DO_PACOTE[p.pacote];
          const seu = atual === p.pacote;
          return (
            <div key={p.pacote} className={`lgl-monitor-pacote${seu ? ' is-atual' : ''}`}>
              <span className="lgl-nome">{p.pacote}</span>
              <span className="lgl-monitor-perguntas">{t('monitorPlano.perguntas', { n: numero(p.perguntas) })}</span>
              <span>
                <span className="lgl-preco">{moeda((anual ? valor * 10 : valor) * 100, 'usd')}</span>{' '}
                <span className="lgl-unidade">{t(anual ? 'monitorPlano.porAno' : 'precos.porMes')}</span>
              </span>
              {seu ? (
                <span className="lgl-atual">{t('monitorPlano.seuPacote')}</span>
              ) : analista ? null : (
                <button
                  type="button"
                  className="sp-btn sp-btn-secondary"
                  disabled={ocupado || !priceId}
                  onClick={() => ir('/monitor-ia/checkout', { priceId })}
                >
                  {t(atual ? 'monitorPlano.trocar' : 'monitorPlano.assinar')}
                </button>
              )}
            </div>
          );
        })}
      </div>
      <p className="lg-nota">{t('monitorPlano.nota')}</p>
      {atual && !analista && (
        <button
          type="button"
          className="sp-btn sp-btn-ghost lgl-monitor-cancelar"
          disabled={ocupado}
          onClick={() => window.confirm(t('monitorPlano.confirmarCancelamento')) && ir('/monitor-ia/cancelar')}
        >
          {t('monitorPlano.cancelar')}
        </button>
      )}
    </section>
  );
};

export default PlanoMonitorIa;
